//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            index: 0,
            bubbleIndex: 0,
            showNext: false
        };
    },

    computed: {
        nickname () {
            return this.$store.getters.nickname;
        }
    },

    methods: {
        nextSpeechBubble () {
            if (this.bubbleIndex === 0) {
                this.bubbleIndex++;
            } else if (this.bubbleIndex === 1) {
                this.bubbleIndex++;
                this.showNext = true;
            }
        },
        goToNextGame () {
            if (this.showNext) {
                this.$router.push({ name: 'next' });
            }
        }
    }
};
